/**
 * Utility functions for calculating burn rewards based on collectible rarity
 */

export interface RarityReward {
  rarity: string
  reward: number
}

// Reward values for burning collectibles by rarity
export const BURN_REWARDS: Record<string, number> = {
  limited: 900,
  legendary: 900,
  epic: 100,
  rare: 18,
  uncommon: 4,
  common: 1
}

/**
 * Get the burn reward for a specific rarity tier
 */
export function getBurnReward(rarity: string): number {
  const normalizedRarity = rarity.toLowerCase()
  return BURN_REWARDS[normalizedRarity] || 0
}

/**
 * Calculate total rewards for multiple items
 */
export function calculateTotalRewards(rarities: string[]): number {
  return rarities.reduce((total, rarity) => total + getBurnReward(rarity), 0)
}

/**
 * Format reward text for display
 */
export function formatRewardText(reward: number): string {
  if (reward === 0) return 'No reward'
  if (reward === 1) return '+1 Total Crack'
  return `+${reward} Total Cracks`
}

/**
 * Get reward breakdown by rarity for multiple items
 */
export function getRewardBreakdown(rarities: string[]): RarityReward[] {
  const breakdown: Record<string, number> = {}
  
  rarities.forEach(rarity => {
    const normalizedRarity = rarity.toLowerCase()
    if (!breakdown[normalizedRarity]) {
      breakdown[normalizedRarity] = 0
    }
    breakdown[normalizedRarity] += getBurnReward(normalizedRarity)
  })
  
  return Object.entries(breakdown)
    .filter(([, reward]) => reward > 0)
    .map(([rarity, reward]) => ({ rarity, reward }))
    .sort((a, b) => b.reward - a.reward) // Sort by reward value descending
}